import { FileCog, Settings2 } from "lucide-react";
import { defineModuleUi } from "@vixio/data";
import { lazyPage } from "@vixio/ui";
import "./api";

export * from "./api";
export { JobResult, JobHistory } from "./jobs";

// Telas carregadas sob demanda: cada uma vira um arquivo à parte no build.
const SettingsPage = lazyPage(() => import("./SettingsPage"), "SettingsPage");
const ToolPage = lazyPage(() => import("./ToolPage"), "ToolPage");
const ToolsPage = lazyPage(() => import("./ToolsPage"), "ToolsPage");

/**
 * Ferramentas PDF: no painel (Documentos → Ferramentas PDF; configurações em Configurações → Ferramentas PDF) e no
 * portal do cliente (/portal/ferramentas-pdf), registrado aqui pelo próprio módulo (portal.menu/portal.routes),
 * sem mexer nos arquivos do portal. O banco decide o que cada um vê (equipe: a organização; cliente: só os próprios).
 */
export default defineModuleUi({
  key: "pdf_tools",
  title: "Ferramentas PDF",
  domain: "documents",
  icon: FileCog,
  menu: [
    {
      path: "/documentos/ferramentas-pdf", label: "Ferramentas PDF", minRole: "member", icon: FileCog, order: 40,
      keywords: "pdf juntar dividir comprimir converter word excel ocr girar senha marca d'água pdf/a assinar ilovepdf",
    },
    {
      path: "/configuracoes/ferramentas-pdf", label: "Ferramentas PDF", minRole: "admin", icon: Settings2, domain: "platform", order: 60,
      keywords: "gotenberg ocr limites cota retenção pdf",
    },
  ],
  routes: [
    { path: "/documentos/ferramentas-pdf", element: <ToolsPage />, minRole: "member" },
    { path: "/documentos/ferramentas-pdf/:tool", element: <ToolPage />, minRole: "member" },
    { path: "/configuracoes/ferramentas-pdf", element: <SettingsPage />, minRole: "admin" },
  ],
  portal: {
    menu: [{ path: "/portal/ferramentas-pdf", label: "Ferramentas PDF", minRole: "client", icon: FileCog, order: 230 }],
    routes: [
      { path: "/portal/ferramentas-pdf", element: <ToolsPage portal />, minRole: "client" },
      { path: "/portal/ferramentas-pdf/:tool", element: <ToolPage portal />, minRole: "client" },
    ],
  },
});
